import {TableHead as MUITableHead} from '@mui/material'
import React from 'react'

interface TableHeadProps extends React.ComponentProps<typeof MUITableHead> {}

export const TableHead: React.FC<TableHeadProps> = (props) => {
  return <MUITableHead {...props} />
}
